import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";

class ModalMaxRelated extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {}

    componentDidMount() {
        this.setState({
            display_warning: this.props.display_warning
        });
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            display_warning: nextProps.display_warning
        });
    }

    _close(){
        this.props.setLeave(false);
    }

    _set(){
        this.props.setLeave(true);
    }

    _renderText(item) {
        return langRegister.get("modal-maxrelated", item);
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon.svg")}/>

                          <div>
                              {
                                  this.state.display_warning === 1 &&
                                  <div className={Styles.overlayModalTitle}>
                                      {this._renderText("item_1")}
                                  </div>
                              }
                              {
                                  this.state.display_warning === 2 &&
                                  <div className={Styles.overlayModalTitle}>
                                      {this._renderText("item_5")}
                                  </div>
                              }
                              {
                                  this.state.display_warning === 3 &&
                                  <div className={Styles.overlayModalTitle}>
                                      {this._renderText("item_6")}
                                  </div>
                              }
                              <div className={Styles.overlayModalText}>
                                  {this._renderText("item_4")}{' '}
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => {this._set()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  ok
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalMaxRelated;


// WEBPACK FOOTER //
// ./src/components/modal-maxrelated/component.js